import { useNavigate } from 'react-router-dom';
import { Button, C, Card, ErrorNote, Muted, SectionTitle, Title } from '../ui';
import { CommerceItem, Stat } from '../components';
import { useCommerces } from '../useCommerces';

const Dashboard = () => {
  const navigate = useNavigate();
  const { commerces, loading, error } = useCommerces();
  const drafts = commerces.filter((c) => c.estado === 'draft');
  const claimed = commerces.filter((c) => c.estado === 'reclamado');
  const recent = commerces.slice(0, 5);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <Title>Resumen</Title>
        <Button onClick={() => navigate('/partner/comercios/nuevo')}>Nuevo comercio</Button>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
        <Stat label="Comercios totales" value={commerces.length} />
        <Stat label="Sin reclamar" value={drafts.length} tone={C.secondary} />
        <Stat label="Reclamados" value={claimed.length} tone={C.success} />
      </div>

      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SectionTitle>Comercios recientes</SectionTitle>
          <Button variant="ghost" onClick={() => navigate('/partner/comercios')}>
            Ver todos
          </Button>
        </div>
        {loading && <Muted>Cargando...</Muted>}
        {error && <ErrorNote>{error}</ErrorNote>}
        {!loading && commerces.length === 0 && <Muted>Aun no has registrado comercios. Crea el primero.</Muted>}
        {recent.map((c) => (
          <CommerceItem key={c.id_suscripcion} c={c} />
        ))}
      </Card>
    </>
  );
};

export default Dashboard;
